import React from 'react'

import styles from './card.module.css'

const Card = ({ variant, children, ...rest }) => {
    const style = ({
        "popup": styles.popup,
        "card": styles.defaultCard,
        "empty": styles.empty,
        "modal": styles.modalCard,
    })[variant]

    return (
        <div {...rest} className={style}>
            {children}
        </div>
    )
}

export default Card